import { Box, Collapse, IconButton, makeStyles, Typography } from "@material-ui/core"
import * as React from "react"
import ChevronDown from "../Icons/chevronDown";
import { SvgIcon } from "../SvgIcon";

interface AccrodionProps {
  open: boolean;
  title: string;
  isDone?: boolean;
  onOpenClose: () => void;
}

export const Accordion: React.FC<AccrodionProps> = ({
  children,
  title,
  open,
  isDone,
  onOpenClose,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
        <div className={classes.heading}>
            <Box display="flex" flexDirection="row" flexWrap="nowrap" alignItems="center">
              <Box mr={1.5}>
                {isDone ? <SvgIcon type="notification" modifier="success" /> : <SvgIcon type="sl-finished" />}
              </Box>
              <Typography className={classes.headingText}>{title}</Typography>
            </Box>
            <IconButton onClick={onOpenClose}>
              <ChevronDown fontSizeAdjust={20} style={{transform: open ? 'rotate(180deg)' : 'rotate(0deg)', transformOrigin: 'center',}} color="primary" />
            </IconButton>
        </div>
        <Collapse in={open}>
          <div className={classes.content}>
            {children}
          </div>
        </Collapse>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    flexFlow: 'column nowrap',
    backgroundColor: '#F0F7FD',
    borderRadius: 4,
    margin: 0,
    marginBottom: 8,
    padding: theme.spacing(2),
  },
  content: {
    padding: theme.spacing(0, 4, 0, 4),
  },
  heading: {
    // paddingBottom: theme.spacing(2),
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
  },
  headingText: {
    fontSize: 15,
    lineHeight: '18px',
    fontWeight: 500,
  },

}))
